import type { NamespaceZodTranslation } from '../../i18n-types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const en_zod = {
	requiredField: 'This field is required',
	dataNoAvailableWait: 'Data are not loaded yet, try it again in a moment',
	maxStringLength: 'Maximum length of text is {max} characters',
	alphabetError: 'Only letters, space or dash are allowed',
	noSlashError: 'Enter the number without a slash',
	numberError: 'Only numbers are allowed',
	phoneNumberExactLength: 'Phone number must have {length} digits',
	phoneNumberLengthRange: 'Phone number must have {min}-{max} digits',
	emailError: 'The field must be a valid email',
	atLeastOneFieldMustBeFilledIn: 'At least one field must be filled in.',
	birthNumberLength:
		'Birth number must have {minBirthNumberLength} or {maxBirthNumberLength} characters',
	insuranceNumberLength:
		'Insurance number must have maximum {maxInsuranceNumberLength} characters',
	negativeAmountNotAllowed: 'Amount cannot be negative',
	amountFromHasToBeLessThanAmountTo:
		'Amount from has to be less than amount to',
	dateToMustBeBeforeDateFrom: 'Date must be later or the same as Date from',
	dateMustBeTodayAtLatest: 'The date must be today at the latest',
	dateCantBeEarlierThanBankInceptionDate:
		'Date cannot be earlier than the bank inception date (1. 11. 2023)',
	dateMustBeAfterOrEqualMin:
		'Date must be greater than or equal to the minimum allowed date',
	dateMustBeBeforeOrEqualToday:
		"Date must be less than or equal to today's date",
	dateMustBeAfterOrEqualToday: 'Date must be today or later',
	changeNationalIdentifierDialog: {
		birthNumberLength:
			'Birth number must have {minBirthNumberLength} or {maxBirthNumberLength} characters',
		birthNumberRemainder:
			'Birth number must be divisible by {number} without remainder',
		birthNumberRegex: 'Enter only numbers without a slash',
		birthNumberInvalid: 'Invalid birth number',
		insuranceNumberLength:
			'Insurance number must have maximum {maxInsuranceNumberLength} characters',
		insuranceNumberRegex:
			'Allowed characters are digits, lowercase and uppercase letters',
		unspecifiedNumberLength:
			'Number must have maximum {maxUnspecifiedNumberLength} characters',
		unspecifiedNumberRegex:
			'Allowed characters are digits, lowercase and uppercase letters',
	},
	applicationsActivations: {
		wrongActivationState:
			'State can only be selected for the activation type "Document verification" or "Advisor QR code"',
		userSubFilterOnlyWithBankId:
			'Identifier is available only in combination with the activation type "Bank iD onboarding" or "Bank iD activation"',
	},
	reportForStateInstitutions: {
		fromAndToDatesHaveToBePicked: 'Select both dates',
		atLeastOneAccountMustBeSelected: 'Select at least one account',
		atLeastOneScopeOptionShouldBeSelected:
			'Select at least one option from section Client or Products',
	},
	advisorIdLength:
		'Advisor ID must be at least {minLength} and at most {maxLength} digits long',
	invalidClientPid: 'Invalid client PID.',
	invalidCharacters: 'Invalid characters in the field',
	documentNumberLength:
		'Document must be at least {minLength} and at most {maxLength} digits long',
	inputMinLength: 'The field must have at least {minLength} {characters}',
} satisfies NamespaceZodTranslation;

export default en_zod;
